import "./App.css";
import FrontPage from "./pages/FrontPage";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import AutecProductDetail from "./pages/AutecProductDetail";
import Contact from "./pages/Contact";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import NewsPage from "./pages/NewsPage";
import NewsDetail from "./pages/NewsDetail";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import { LanguageProvider } from "./utils/i18n";

function ScrollToTop() {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (state?.restoreScroll) return;
    window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<FrontPage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/autecproducts" element={<Products />} />
        <Route path="/autecproducts/:slug" element={<AutecProductDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
